export default "__VITE_ASSET__CKdO12lS__"